// extracted by mini-css-extract-plugin
export default {"oldDiffValue":"Diff_oldDiffValue__fJqqO","diffIcon":"Diff_diffIcon__3zC+U","newDiffValue":"Diff_newDiffValue__HM-yQ"};